import React, { useEffect, useMemo, useState } from 'react';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useTableContext } from '../../contexts/TableContext';

//Componentes
import Table from './Table';

function TableContainer({ tableData }) {
    // const { tablePage, setTablePage } = useGlobalContext();
    const { state, dispatch } = useTableContext();
    const { pageType, pagination, data } = tableData;
    const pages = useMemo(
        !tableData.tablePages
            ? () => Math.ceil(data.length / pagination)
            : () => Math.ceil(tableData.tablePages / pagination)
    );
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        setCurrentPage(state[pageType] ?? 1);
    }, [state[pageType]]);

    const nextPage = () => {
        if (currentPage !== pages) {
            setCurrentPage(parseInt(currentPage + 1));
            dispatch({
                type: 'NEXT_PAGE',
                tableType: pageType,
            });
            // if (onPageChange) onPageChange();
        } else {
            return currentPage;
        }
    };

    const previousPage = () => {
        if (currentPage !== 1) {
            setCurrentPage(parseInt(currentPage - 1));
            dispatch({
                type: 'PREVIOUS_PAGE',
                tableType: pageType,
            });
        } else {
            return currentPage;
        }
    };

    const changePage = (e) => {
        if (e.target.value >= 1 && e.target.value <= pages) {
            setCurrentPage(parseInt(e.target.value));
            dispatch({
                type: 'INPUT_PAGE',
                tableType: pageType,
                payload: parseInt(e.target.value),
            });
        } else {
            return currentPage;
        }
    };

    const getPaginatedData = () => {
        if (pagination && !tableData.tablePages) {
            const startIndex = currentPage * pagination - pagination;
            const endIndex = startIndex + pagination;
            return data.slice(startIndex, endIndex);
        } else {
            return data;
        }
    };

    const functions = {
        getPaginatedData,
        nextPage,
        previousPage,
        changePage,
    };

    return (
        <Table
            tableData={tableData}
            functions={functions}
            currentPage={currentPage}
            pages={pages}
        />
    );
}

export default TableContainer;
